import config from '$/config';
import EDate from '$/shared/frontend/utils/EDate';

export const isValidSessionTime = (sessionTime?: string | null): boolean => {
  /* Uses EDate instead of dayjs library */
  if (!sessionTime) return false;
  if (sessionTime === 'replay') {
    return true;
  }

  if (sessionTime === 'ondemand') {
    return true;
  }

  try {
    const sessionTimeMoment = new EDate(sessionTime, 'UTC');
    return sessionTimeMoment.isAfter(
      new EDate(new Date(Date.now()), 'UTC').subtractMinutes(
        config.MINUTES_ALLOW_TO_REGISTER_AFTER_WEBINAR_START
      )
    );
  } catch {
    return false;
  }
};
